<template>
  <div class="oilslist">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="消费订单" name="first">
        <oils-list :allOrder="5"></oils-list>
      </el-tab-pane>
      <el-tab-pane label="充值订单" name="second">
        <voucher-list :isvoucher="1"></voucher-list>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import OilsList from "./oilsList";
import VoucherList from "./voucherList"
export default {
  components: {
    OilsList,
    VoucherList
  },
  data(){
    return{
      activeName:'first'
    }
  },
  methods:{
    handleClick(e){
      this.activeName = e.name
    },
  }
};
</script>
<style lang="scss" scoped>
.oilslist {
  height: 100%;
  overflow: auto;
  padding: 20px;
}
</style>